export const parsePollOption = (option: string) => {
  // eslint-disable-next-line no-useless-escape
  return option.replace(/\*\!\d+\!\*/, "")
}

export const stringifyPollOption = (count: number, choice: string) => {
  return `*!${count}!*${choice}`
}

export const sortPollOptions = obj => {
  const sortedObj = {}
  Object.keys(obj)
    .sort()
    .forEach(key => {
      sortedObj[key] = obj[key]
    })
  return sortedObj
}
